<template>
    <v-dialog @click:outside="close" ref="earlyDialog" v-model="isDialog" width="808px" height="620px">
        <v-sheet height="620px">
            <div class="dialog-header">
                <h4 class="dialog-header__title">ВНИМАНИЕ!</h4>
                <v-icon @click="close" color="white">mdi-close</v-icon>
            </div>
            <div class="dialog-body">
                <div class="bold">
                    {{ confirmText }}
                </div>
                <CustomActivatorSelect
                    style="width: 100%"
                    :items="filteredActivations"
                    :item-name="'name'"
                    :item-value="'id'"
                    v-model="selected"
                    :multiple="true"
                    :menu-props="{ top: false, offsetY: true }"
                >
                    <template v-slot:activator="{ selected, _id }">
                        <TextField
                            label="Активации"
                            hide-details
                            class="select-input bot-select"
                            append-icon="mdi-menu-down"
                            :id="_id"
                            :value="textFieldActiveString"
                            readonly
                        />
                    </template>
                </CustomActivatorSelect>
                <v-spacer></v-spacer>
                <div class="mt-2">
                    Введите слово "Удалить" для подтверждения удаления
                </div>

                <TextField 
                class="mt-2 delete-input"
                placeholder="Удалить"
                hideDetails
                v-model="text"
                />
            </div>
            <v-row class="ma-0 mt-6 pr-4" style="width: 100%">
                <v-spacer></v-spacer>
                <div style="height: 36px;">
                    <v-btn 
                        variant="contained" 
                        color="error" 
                        class="white--text" 
                        :loading="loading" 
                        @click="deleteActivations"
                        :disabled="text !== 'Удалить'"
                    >
                        <div class="btn-inner">
                            <v-icon size="20" color="white">mdi-delete-outline</v-icon>
                            Удалить
                        </div>
                    </v-btn>
                    <v-btn
                        elevation="0"
                        outlined
                        class="outlined-btn ml-4"
                        @click="close"
                    >ОТМЕНА</v-btn>
                </div>
            </v-row>
        </v-sheet>
    </v-dialog>
</template>
<script>
import Vue, { PropType } from 'vue'
import TextField from '../../../inputs/TextField.vue'
import { ActivationToEdit } from '@root/src/types/GCB2'
import CustomActivatorSelect from '@root/src/components/inputs/CustomActivatorSelect.vue'
import { bulkDeleteActivations } from '@root/src/api/chisai/GCB2'

export default Vue.extend({
    name: 'DeletionActivationsModal',
    components: { TextField, CustomActivatorSelect },
    props: {
        value: { type: Boolean },
        activations: {required: true, type: Array},
        activationsToDelete : {required: true, type: Array},
        filteredActivationsIds : {required: true, type: Array}
    },
    data: () => ({
        loading : false,
        text : "",
        selected : []
    }),
    watch: {
        isDialog(val) {
            if (val) {
                this.selected = this.activationsToDelete.map(el => el.id)
            } else {
                this.selected = []
            }
        }
    },
    computed: {
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        isDialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
        isSingle() {
            return this.selected.length > 1 ? false : true
        },
        activationsCount() {
            return this.selected.length
        },
        confirmText() {
            if (this.isSingle) {
                return "Вы действительно хотите удалить выбранную активацию?"
            } else {
                return `Вы действительно хотите удалить выбранные активации (${this.activationsCount})?`
            }
        },
        textFieldActiveString() {
            if(this.selected.length === this.filteredActivations.length) {
                return `Выбраны все активации(${this.selected.length})`
            } else {
                return `Активации(${this.selected.length})`
            }
        },
        filteredActivations() {
            return this.activations.filter(el => this.filteredActivationsIds.includes(el.id))
        }
    },
    methods: {
        async deleteActivations() {
            if (this.selected.length === 0) {
                this.$store.dispatch('callNotify', `Вы ничего не выбрали`)
            } else {
                this.loading = true
                const res = await bulkDeleteActivations({
                    projectId: this.project.id,
                    activationIds: this.selected
                })
                if(res.error) {
                    this.$store.dispatch('callNotify', `Ошибка при удалении`)
                }
                this.$emit('filter-after-delete', this.selected)              
                this.loading = false
                this.close()
            }            
        },

        close() {
            this.text = ''
            this.isDialog = false
        },
    }
})
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.bold 
    font-weight: 600
.btn-inner 
    display: flex
    align-items: center
    gap: 8px
    color: #fff

.dialog-header
    display: flex
    height: 48px
    width: 808px
    background: $main
    color: white
    justify-content: space-between
    align-items: center
    padding: 0 16px
    .dialog-header__title
        color: white
        font-size: 14px
        letter-spacing: 1.25px
        font-weight: normal
.dialog-body
    width: 100%
    height: calc(100% - 120px)
    display: flex
    flex-direction: column
    padding: 15px 16px 25px 16px
    overflow-x: auto
::v-deep .v-dialog
    overflow: hidden !important
.delete-input
    height: 57px !important
    max-height: 57px !important

</style>
